export default "__VITE_ASSET__DwY9tl2N__"